// Check if running locally
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || (isLocalhost ? 'http://localhost:8080' : 'https://api.prostopodpishi.ru')
};

export default config; 